import dayjs from 'dayjs'
import type { NavigateAction } from 'react-big-calendar'
// rbc ships no types for its internal TimeGrid; see react-big-calendar.d.ts.
import TimeGrid from 'react-big-calendar/lib/TimeGrid'
import { TEN_DAY_SPAN } from '@jupi/shared'

export const TEN_DAY_VIEW = 'tenDay' as const

// A rolling view: ten days starting on the selected one. Week snaps back to
// Monday, which shows days already gone; a pilot planning ahead wants today
// first.
type TenDayComponent = ((props: any) => React.JSX.Element) & {
  range: (date: Date) => Date[]
  navigate: (date: Date, action: NavigateAction) => Date
  title: (date: Date) => string
}

// What rbc's own Week does for TimeGrid: default min, max (the hours shown)
// and scrollToTime from the localizer, and TimeGrid's own step and timeslots.
// A custom view gets none of that, and without min and max the grid has no
// hours at all: no time column and no slots. (React 19 ignores defaultProps on
// a function component, hence spreading them.)
const TenDay = ((props: any) => {
  const { localizer } = props
  return (
    <TimeGrid
      {...(TimeGrid as any).defaultProps}
      {...props}
      min={props.min ?? localizer.startOf(new Date(), 'day')}
      max={props.max ?? localizer.endOf(new Date(), 'day')}
      scrollToTime={props.scrollToTime ?? localizer.startOf(new Date(), 'day')}
      enableAutoScroll={props.enableAutoScroll ?? true}
      range={TenDay.range(props.date)}
      eventOffset={15}
    />
  )
}) as unknown as TenDayComponent

TenDay.range = (date: Date) =>
  Array.from({ length: TEN_DAY_SPAN }, (_, i) => dayjs(date).startOf('day').add(i, 'day').toDate())

TenDay.navigate = (date: Date, action: NavigateAction) => {
  if (action === 'PREV') return dayjs(date).subtract(TEN_DAY_SPAN, 'day').toDate()
  if (action === 'NEXT') return dayjs(date).add(TEN_DAY_SPAN, 'day').toDate()
  return date
}

TenDay.title = (date: Date) => {
  const range = TenDay.range(date)
  return `${dayjs(range[0]).format('L')} – ${dayjs(range[range.length - 1]).format('L')}`
}

export default TenDay
